import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import BaseCell from '../base-cell/index';
import { newLineSeparator } from "../../../../utils/textUtil.js";
import CustomButton from '../button-cell/custom-button';

export default class CarouselCell extends BaseCell {

  render() {
    const {carousels, baseParams} = this.props;
    const buttonStyle = super.getButtonStyle(baseParams);

    return (
      <div className={'cu-ui-carousel'}>
        <div className={'cu-ui-carousel-slides cu-ui-text-count-data'} { ...this.textCountCustomAttributes }>
          {
            map(carousels, (c, idx) => {
              return (
                <Carousel
                  key={`${idx}-${c.title}`}
                  placeholder={c.placeholder}
                  title={c.title}
                  explain={c.explain}
                  buttons={c.buttons}
                  buttonStyle={buttonStyle}
                />
              );
            })
          }
          <div className={'cu-ui-carousel-slide cu-ui-carousel-slide-last'}></div>
        </div>
      </div>
    );
  }
}

function Carousel({placeholder, title, explain, buttons, buttonStyle}) {

  return (
    <div className={'cu-ui-carousel-slide'}>
      <div className={'cu-ui-carousel-image'} style={{
        backgroundImage: placeholder ? `url(${placeholder})` : 'none'
      }}>
        <div className={'cu-ui-carousel-placeholder'}></div>
      </div>
      <div className={'cu-ui-carousel-text'}>
        <h5 className={'title cu-ui-carousel-text-html'} dangerouslySetInnerHTML={{ __html: title }} />
        <div className={'cu-ui-carousel-text-html'} dangerouslySetInnerHTML={{ __html: explain }} />
      </div>
      <div className={'cu-ui-carousel-buttons'}>
        {
          map(buttons, (b, idx) => {
            return (
              <CustomButton
                button={b}
                buttonType={'carousel'}
                key={`${idx}-${b}`}
                style={buttonStyle}
              />
            );
          })
        }
      </div>
    </div>
  );
}

CarouselCell.propTypes = {
  carousels: PropTypes.array
};
